import { io } from "socket.io-client";
import { apiUrl } from "./api";

const SOCKET_URL = apiUrl; // <-- Replace with your API URL

// Create a single socket instance
export const socket = io(SOCKET_URL, {
    transports: ["websocket"],
    reconnection: true,
    reconnectionAttempts: 15,
    reconnectionDelay: 1000,
});

// Debug connection status
socket.on("connect", () => {
    console.log("🟢 Socket connected:", socket.id);
});

socket.on("disconnect", () => {
    console.log("🔴 Socket disconnected");
});

socket.on("connect_error", (err) => {
    console.log("⚠️ Socket connection error:", err.message);
});
